"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPassword = exports.isLongEnoughPassword = exports.isValidPostalOrZipCode = exports.isValidPhoneNumber = exports.isValidEmail = void 0;
const MINIMUM_PASSWORD_LENGTH = 8;
function isValidEmail(email) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
}
exports.isValidEmail = isValidEmail;
function isValidPhoneNumber(phoneNumber) {
    const phoneNumberRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
    return phoneNumberRegex.test(phoneNumber);
}
exports.isValidPhoneNumber = isValidPhoneNumber;
function isValidPostalOrZipCode(postalOrZipCode, countryId) {
    let postalOrZipCodeRegex;
    switch (countryId) {
        case "CA":
            postalOrZipCodeRegex = /^[abceghjklmnprstvxy][0-9][abceghjklmnprstvwxyz]\s?[0-9][abceghjklmnprstvwxyz][0-9]$/i;
            break;
        case "US":
            postalOrZipCodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
            break;
        default:
            postalOrZipCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
    }
    return postalOrZipCodeRegex.test(postalOrZipCode);
}
exports.isValidPostalOrZipCode = isValidPostalOrZipCode;
function isLongEnoughPassword(password) {
    return password.length >= MINIMUM_PASSWORD_LENGTH;
}
exports.isLongEnoughPassword = isLongEnoughPassword;
function isValidPassword(password) {
    const passwordRegex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/;
    return passwordRegex.test(password);
}
exports.isValidPassword = isValidPassword;
//# sourceMappingURL=formValidationHelper.js.map